import { CALL_API } from "../api.middleware";
import {
  GET_DIST_POST_QUERY_DATA,
  GET_DIST_POST_QUERY_DATA_SUCCESS,
  GET_DIST_POST_QUERY_DATA_FAILED
} from "../types/support";

export const getDistPostQuery = params => async dispatch => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetDistPostQryData",
        params,
        method: "GET",
        types: [
          GET_DIST_POST_QUERY_DATA,
          GET_DIST_POST_QUERY_DATA_SUCCESS,
          GET_DIST_POST_QUERY_DATA_FAILED
        ]
      }
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getComplaint = body => async dispatch => {
  try {
    return await dispatch({
      [CALL_API]: {
        isTrackApi: true,
        url: "/GetComplaint",
        body,
        method: "POST"
      }
    });
  } catch (error) {
    alert(`${error}`);
  }
};
